import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@/index.css";

class AppErrorBoundary extends React.Component<
  React.PropsWithChildren,
  { error: Error | null }
> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <main className="flex min-h-screen items-center justify-center bg-background p-6 text-foreground">
          <div className="w-full max-w-lg rounded-xl border border-border bg-card p-5">
            <h1 className="text-lg font-semibold">k6waifus failed to load</h1>
            <p className="mt-2 text-sm text-muted-foreground">Refresh the page. If it still appears, open the browser console and check the error below:</p>
            <pre className="mt-3 overflow-auto rounded-md bg-muted p-3 text-xs text-red-200">{this.state.error.message}</pre>
          </div>
        </main>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
